/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreatePlaidSandboxPublicTokenRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/testing/CreatePlaidSandboxPublicToken.pb'
import {CreatePlaidSandboxPublicTokenResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/testing/CreatePlaidSandboxPublicToken.pb'


export const createPlaidSandboxPublicToken = (request: CreatePlaidSandboxPublicTokenRequest, options?: CashRequestOptions) => post<CreatePlaidSandboxPublicTokenRequest, CreatePlaidSandboxPublicTokenResponse>("/2.0/cash/create-plaid-sandbox-public-token", request, {...options, rejectOnError: true })